export default function Phase6() {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Phase Header */}
        <div className="flex items-center justify-center mb-8">
          <img 
            src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160517458/settings_images/c821fd2-60ad-dfbb-b7b-3c7076dbb748_0a9554db-dfc8-42b5-bbf2-fe0e7fe8eafe.png" 
            alt="Phase Icon" 
            className="w-16 h-16"
          />
        </div>

        <div className="max-w-4xl mx-auto text-left mb-12">
          <h4 className="text-xl font-bold text-gray-900 mb-2">
            <span>Phase 5:</span>
          </h4>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
            <span>AI Studio Upgrade</span>
          </h2>
        </div>

        {/* Before/After Videos */}
        <div className="grid md:grid-cols-2 gap-8 mb-12 max-w-5xl mx-auto">
          <div 
            className="relative w-full overflow-hidden rounded-lg" 
            style={{ 
              paddingBottom: '56.25%',
              touchAction: 'pan-y',
              WebkitOverflowScrolling: 'touch'
            }}
          >
            <iframe 
              src="https://player.mediadelivery.net/embed/555127/92a7a3c9-8899-4550-8a7e-7d9e5d7f1fa1?autoplay=true&loop=true&muted=true&playsinline=true" 
              title="Ai studio before Video" 
              allow="autoplay; fullscreen" 
              allowFullScreen
              className="absolute top-0 left-0 w-full h-full rounded-lg"
              style={{ 
                border: 'none',
                pointerEvents: 'auto',
                maxWidth: '100%',
                maxHeight: '100%'
              }}
              loading="lazy"
            ></iframe>
          </div>
          <div 
            className="relative w-full overflow-hidden rounded-lg" 
            style={{ 
              paddingBottom: '56.25%',
              touchAction: 'pan-y',
              WebkitOverflowScrolling: 'touch'
            }}
          >
            <iframe 
              src="https://player.mediadelivery.net/embed/555127/7f7aeb82-f7f6-4389-9e0d-1ad3bb96fc58?autoplay=true&loop=true&muted=true&playsinline=true" 
              title="Ai studio after Video" 
              allow="autoplay; fullscreen" 
              allowFullScreen
              className="absolute top-0 left-0 w-full h-full rounded-lg"
              style={{ 
                border: 'none',
                pointerEvents: 'auto',
                maxWidth: '100%',
                maxHeight: '100%'
              }}
              loading="lazy"
            ></iframe>
          </div>
        </div>

        {/* Content */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow-md p-8">
            <p className="text-base text-gray-700 mb-4">When you're just starting, you probably won't have a full content studio.</p>
            <p className="text-base text-gray-700 mb-4">That's fine!</p>
            <p className="text-base text-gray-700 mb-4"><strong><span>All you need is a blank wall.</span></strong></p>
            <p className="text-base text-gray-700 mb-4">AI can do the rest!</p>
            <p className="text-base text-gray-700 mb-2">✅ Works in any editing program</p>
            <p className="text-base text-gray-700 mb-2"><span>✅ Works with any camera</span></p>
            <p className="text-base text-gray-700 mb-2"><span>✅ Several different AI tools can do this</span></p>
            <p className="text-base text-gray-700"><span>✅ Customize a new background anytime you film!</span></p>
          </div>
        </div>
      </div>
    </section>
  );
}
